import { NotificationStatus } from '@arritech/shared/types';

export const ChecklistStatus = {
	...NotificationStatus,
	IDLE: 'idle',
} as const;

export type ChecklistStatus =
	(typeof ChecklistStatus)[keyof typeof ChecklistStatus];

export interface ChecklistItem {
	id?: string | number;
	label: string;
	status: ChecklistStatus;
}

export interface ChecklistProps {
	title?: string;
	items: ChecklistItem[];
}
